/**
 * get mime type by file name or any string with extension
 *
 * if none matched, return "text/plain"
 *
 * for a full list of mime type:
 * @see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
 */
export default function getMIMETypeByFileName(fileName = "") {
  const fileExt = fileName.split(".");
  if (fileExt.length < 2) {
    // fallback to default
    return "text/plain";
  }
  /**
   * arbitrary txt
   */
  const fileType = (fileExt[fileExt.length - 1] || "").toLowerCase();
  let genre = "text";
  let type = fileType || "plain";
  // image
  if (["bmp", "jpeg", "jpg", "png", "gif", "tif", "tiff"].includes(fileType)) {
    genre = "image";
    if (fileType === "jpg") {
      type = "jpeg";
    } else if (fileType === "tif") {
      type = "tiff";
    }
  }
  // file
  else if (["pdf"].includes(fileType)) {
    genre = "application";
  }
  // video
  else if (["mp4", "mpeg"].includes(fileType)) {
    genre = "video";
  }
  // audio
  else if (["mp3"].includes(fileType)) {
    genre = "audio";
    type = "mpeg";
  }
  // zip
  else if (["zip"].includes(fileType)) {
    genre = "application";
    type = "zip";
  }

  return `${genre}/${type}`;
}
